import ScrollLock from '../../components/scroll-lock/scroll-lock';
import axios from 'axios';

class Siteheader {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-siteheader'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$siteheader = element;
        this.eventScroller = window.eventScroller;
        this.$navigationToggle = this.$siteheader.querySelector('[data-nav="rootToggle"]');
        this.$searchOverlayToggleCheckbox = this.$siteheader.querySelector('[data-nav="search_toggle"]');
        this.$siteHeaderSearchOverlay = this.$siteheader.querySelector('[data-nav="search_overlay"]');
        this.$siteHeaderMetaNav = this.$siteheader.querySelector('[data-siteheader="meta-nav"]');
        this.$conferenceTeaserListSidebar = document.querySelector('.conference-teaser-list__sidebar');
        this.$siteMain = document.querySelector('[data-main="root"]');
        this.cartCount = 0;
    }

    initialize () {
        this.setEvents();

        if (this.$siteHeaderMetaNav) {
            this.handleCartCount();
        }
    }

    handleCartCount () {
        const $$shopBasketIndicator = this.$siteheader.querySelectorAll('[data-basket]');

        if ($$shopBasketIndicator.length > 0) {
            $$shopBasketIndicator.forEach(($shopBasketIndicator) => {
                const $cartContRoute = $shopBasketIndicator.dataset.cartItemsRoute;

                if ($cartContRoute) {
                    axios({
                        method: 'GET',
                        url: $cartContRoute,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    }).then((result) => {
                        if (result) {
                            this.cartCount = result.data;

                            $shopBasketIndicator.textContent = this.cartCount;

                            if (this.cartCount < 1) {
                                $shopBasketIndicator.classList.remove('is--active');
                            } else {
                                $shopBasketIndicator.classList.add('is--active');
                            }
                        }
                    }).catch((error) => {
                        throw Error(error);
                    });
                }
            });
        }
    }

    setEvents () {
        // clean up open states and locks
        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (match.matches) {
                this.closeNav();
            } else {
                this.closeNav();
            }
        });

        // close navigation on orientationchange
        window.addEventListener('orientationchange', () => {
            this.closeNav();
        });

        // close navigation on outside click
        document.addEventListener('click', (e) => {
            if (!this.$siteheader.contains(e.target)) {
                this.closeNav();
            }
        });

        // close navigation on outside focus
        if (this.$siteMain && this.$navigationToggle) {
            this.$siteMain.addEventListener('focus', (e) => {
                if (!this.$siteheader.contains(e.target)) {
                    this.closeNav();
                }
            });
        }

        // close navigation on the ESC key
        document.addEventListener('keydown', (e) => {
            if (e.code === 'Escape' || e.key === 'Esc') {
                if (this.$siteheader.contains(e.target)) {
                    this.closeNav();
                }
            }
        });

        window.addEventListener('checkbox.trigger.click', (e) => {
            if (e.detail.checkbox) {
                this.closeNav(e.detail.checkbox);
            }
        });

        window.addEventListener('checkbox.trigger.active', (e) => {
            if (this.$searchOverlayToggleCheckbox === e.detail.checkbox) {
                this.checkSearchToggle();
            }

            if (this.$navigationToggle === e.detail.checkbox) {
                if (e.detail.state === true) {
                    ScrollLock.disableScroll();
                } else {
                    ScrollLock.enableScroll();
                }
            }
        });
    }

    closeNav (currentElement = null) {
        if ((currentElement === this.$searchOverlayToggleCheckbox || currentElement === null) && this.$navigationToggle.checked) {
            window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    referenceId: this.$navigationToggle.id,
                    state: false
                }
            }));

            // cleanup scroll lock
            ScrollLock.disableScroll();
            ScrollLock.enableScroll();
        }

        if ((currentElement !== this.$searchOverlayToggleCheckbox || currentElement === this.$navigationToggle || currentElement === null) && this.$searchOverlayToggleCheckbox.checked) {
            window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    referenceId: this.$searchOverlayToggleCheckbox.id,
                    state: false
                }
            }));

            this.handleAriaStates(this.$siteHeaderSearchOverlay, false);

            // cleanup scroll lock
            ScrollLock.disableScroll();
            ScrollLock.enableScroll();
        }

        if (window.mediaMatch[1024].matches) {
            const $$openNavElement = this.$siteheader.querySelectorAll('[data-nav="toggle"]:checked');

            if ($$openNavElement.length > 0) {
                $$openNavElement.forEach(($openNavElement) => {
                    if ($openNavElement !== currentElement) {
                        window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                referenceId: $openNavElement.id,
                                state: false
                            }
                        }));
                    }
                });
            }
        }

        // cleanup scroll lock on if the screen is > 1024px
        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (match.matches) {
                ScrollLock.disableScroll();
                ScrollLock.enableScroll();
            }
        });
    }

    checkSearchToggle () {
        if (this.$navigationToggle.checked) {
            window.dispatchEvent(new CustomEvent('checkbox.trigger.reset', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    referenceId: this.$navigationToggle.id,
                    state: false
                }
            }));
        }

        if (this.$searchOverlayToggleCheckbox.checked) {
            this.handleAriaStates(this.$siteHeaderSearchOverlay, true);
            ScrollLock.disableScroll();
        } else {
            this.handleAriaStates(this.$siteHeaderSearchOverlay, false);
            ScrollLock.enableScroll();
        }
    }

    handleAriaStates ($content, state) {
        if (state) {
            $content.removeAttribute('inert');
        } else {
            $content.setAttribute('inert', '');
        }
    }
}

export default Siteheader;
